import {
  ApplicationFeeResponse,
  ApplicationService,
  ExchanegeRateService,
  type ApplicationAgentContractResponse,
  type ApplicationContractResponse,
  type ApplicationDocumentResponse,
  type ApplicationExchangeRateResponse,
  type ApplicationParticipantsResponse,
  type ApplicationResponse,
  type ExchangeRate2Response,
} from '@acme/api';
import { createEffect } from 'effector';

export const loadApplicationFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ApplicationService.getApiV1Application({ id });
    if (!res.isSuccess || !res.data) {
      throw new Error(res.errorText || 'Не удалось загрузить заявку');
    }
    return res.data as ApplicationResponse;
  }
);

export const loadContractFx = createEffect(async ({ id }: { id: string }) => {
  const res = await ApplicationService.getApiV1ApplicationContract({ id });
  if (!res.isSuccess) {
    throw new Error(res.errorText || 'Не удалось загрузить контракт заявки');
  }
  return (res.data ?? null) as ApplicationContractResponse | null;
});

export const loadAgentContractFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ApplicationService.getApiV1ApplicationAgentContract({
      id,
    });
    if (!res.isSuccess) {
      throw new Error(
        res.errorText || 'Не удалось загрузить контракт с агентом'
      );
    }
    return (res.data ?? null) as ApplicationAgentContractResponse | null;
  }
);

export const loadFeesFx = createEffect(async ({ id }: { id: string }) => {
  const res = await ApplicationService.getApiV1ApplicationFee({
    id,
  });
  if (!res.isSuccess) {
    throw new Error(res.errorText || 'Не удалось загрузить контракт с агентом');
  }
  return (res.data ?? null) as ApplicationFeeResponse | null;
});

export const loadParticipantsFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ApplicationService.getApiV1ApplicationParticipants({
      id,
    });
    if (!res.isSuccess) {
      return null;
    }
    return (res.data ?? null) as ApplicationParticipantsResponse | null;
  }
);

export const loadApplicationLiquidityProvidersFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ApplicationService.getApiV1ApplicationExchangeOffers({
      id,
    });
    if (!res.isSuccess) {
      throw new Error(
        res.errorText || 'Не удалось загрузить поставщиков по заявке'
      );
    }
    return (res.data ?? []) as ApplicationExchangeRateResponse[];
  }
);

export const loadApplicationDocumentsFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ApplicationService.getApiV1ApplicationDocument1({ id });
    if (!res.isSuccess) {
      return [];
    }
    return (res.data ?? []) as ApplicationDocumentResponse[];
  }
);

export const loadLiquidityProvidersFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ExchanegeRateService.getApiV1ExchanegeRateProviders({
      applicationId: id,
    });
    if (!res.isSuccess) {
      throw new Error(
        res.errorText || 'Не удалось загрузить поставщиков ликвидности'
      );
    }
    return (res.data ?? []) as ExchangeRate2Response[];
  }
);
